module.exports = __webpack_public_path__ + "static/img/view5-2.97f0897.png";


//////////////////
// WEBPACK FOOTER
// ./src/components/lobby/components1030/img/1030/view5-2.png
// module id = ceqn
// module chunks = 1